import { gql } from '@apollo/client';

export const COMPANIES_PAGE_QUERY = gql`
  query companies(
    $limit: Int!
    $offset: Int!
    $companyTypeId: Int
    $parentCompanyId: Int
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    companies(
      limit: $limit
      offset: $offset
      companyTypeId: $companyTypeId
      parentCompanyId: $parentCompanyId
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      hasDraft
      currentVersion {
        annualRevenue
        deletedAt
        businessRegistrationNumber
        code
        companyId
        companyTypes {
          id
          currentVersion {
            id
            name
            deletedAt
          }
        }
        preferredResultFamilyId
        createdById
        dbaName
        description
        displayName
        dnbCompanyName
        dunsNumber
        id
        internalRefNumber
        localName
        logo
        mainEmail
        mainFaxLine
        mainPhoneLine
        naicsCode
        naicsDescription
        name
        parentCompanyId
        sicCode
        sicDescription
        status
        tickerSymbol
        totalEmployees
        updatedById
        version
        defaultCompanyPaymentTerm
        companyLinks {
          id
          currentVersion {
            link
            linkTypeId
          }
        }
      }
    }
    companiesPageInfo(
      companyTypeId: $companyTypeId
      parentCompanyId: $parentCompanyId
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;

export const COMPANIES_ARRAY_QUERY = gql`
query companiesArray($id: [Int!]!) {
  companiesArray(id: $id) {
    id
    currentVersion {
      name
      deletedAt
    }
  }
}
`;

export const COMPANIES_QUERY = gql`
  query companies(
    $limit: Int!
    $offset: Int!
    $companyTypeId: Int
    $parentCompanyId: Int
    $q: String
    $withDeleted: Boolean
  ) {
    companies(
      limit: $limit
      offset: $offset
      companyTypeId: $companyTypeId
      parentCompanyId: $parentCompanyId
      q: $q
      withDeleted: $withDeleted
    ) {
      id
      hasDraft
      currentVersion {
        deletedAt
        annualRevenue
        businessRegistrationNumber
        code
        companyId
        companyTypes {
          id
        }
        preferredResultFamilyId
        createdById
        dbaName
        description
        displayName
        dnbCompanyName
        dunsNumber
        id
        internalRefNumber
        localName
        logo
        mainEmail
        mainFaxLine
        mainPhoneLine
        naicsCode
        naicsDescription
        name
        parentCompanyId
        sicCode
        sicDescription
        status
        tickerSymbol
        totalEmployees
        updatedById
        version
        companyLinks {
          id
          currentVersion {
            link
            linkTypeId
          }
        }
      }
    }
  }
`;

export const COMPANY_QUERY = gql`
  query company($id: Int!) {
    company(id: $id) {
      id
      currentVersion {
        annualRevenue
        deletedAt
        businessRegistrationNumber
        code
        companyId
        preferredResultFamilyId
        preferredResultFamily {
          id
          currentVersion {
            id
            code
            createdById
            id
            name
            resultFamilyId
            status
            updatedAt
            updatedById
            version
            resultFamilyOutcomes {
              id
              resultId
              resultCategoryId
              result {
                id
                currentVersion {
                  id
                  code
                  description
                }
              }
            }
          }
        }
        createdById
        dbaName
        description
        displayName
        dnbCompanyName
        dunsNumber
        id
        internalRefNumber
        localName
        logo
        mainEmail
        mainFaxLine
        mainPhoneLine
        naicsCode
        naicsDescription
        name
        parentCompanyId
        sicCode
        sicDescription
        status
        tickerSymbol
        totalEmployees
        updatedById
        version
        defaultCompanyPaymentTerm
        productTaxonomies {
          id
        }
        companyTypes {
          id
        }
        companyLinks {
          id
          currentVersion {
            link
            linkTypeId
          }
        }
        companyAddresses {
          id
          companyId
          currentVersion {
            id
            address1
            address2
            name
            city
            code
            countryId
            stateProvinceId
            id
            latitude
            longitude
            poZipCode
            addressTypeId
            version
          }
        }
        companyAttachments {
          id
          attachmentId
          filesize
          name
          updatedAt
          deletedAt
        }
        companyContacts {
          id
          companyId
          currentVersion {
            id
            assistantName
            assistantPhone
            businessUnitId
            userId
            companyContactId
            createdById
            departmentId
            directWorkPhone
            doNotCall
            emailOptOut
            fax
            firstName
            homePhone
            id
            lastName
            localFirstName
            localLastName
            localMiddleName
            mailingAddressLine1
            mailingAddressLine2
            mailingCountryId
            mailingPoZipCode
            mailingStateProvinceId
            middleName
            mobilePhone
            notes
            otherAddressLine1
            otherAddressLine2
            otherCity
            otherCountryId
            otherPhone
            otherPoZipCode
            otherStateProvinceId
            personalEmail
            preferredLanguageId
            receiveAbbreviatedReportPdf
            receiveArtifactsAsLinks
            receiveFinalReportPdf
            receiveInvoice
            receiveQuote
            salutation
            status
            suffix
            title
            updatedById
            version
            workEmail
          }
        }
      }
    }
  }
`;

export const COMPANY_VERSIONS_QUERY = gql`
  query companyVersions($companyId: Int!, $limit: Int, $offset: Int) {
    companyVersions(companyId: $companyId, limit: $limit, offset: $offset) {
      annualRevenue
      businessRegistrationNumber
      code
      deletedAt
      companyId
      companyTypes {
        id
      }
      preferredResultFamilyId
      createdAt
      createdById
      dbaName
      description
      displayName
      dnbCompanyName
      dunsNumber
      id
      internalRefNumber
      localName
      logo
      mainEmail
      mainFaxLine
      mainPhoneLine
      naicsCode
      naicsDescription
      name
      parentCompanyId
      sicCode
      sicDescription
      status
      tickerSymbol
      totalEmployees
      updatedAt
      updatedById
      version
      defaultCompanyPaymentTerm
      companyLinks {
        id
        currentVersion {
          link
          linkTypeId
        }
      }
      companyAddresses {
        id
        companyId
        currentVersion {
          id
          address1
          address2
          name
          city
          code
          countryId
          stateProvinceId
          id
          latitude
          longitude
          poZipCode
          addressTypeId
          version
        }
      }
      companyAttachments {
        id
        attachmentId
        filesize
        name
        updatedAt
        deletedAt
      }
      companyContacts {
        id
        companyId
        currentVersion {
          id
          assistantName
          assistantPhone
          businessUnitId
          userId
          companyContactId
          createdById
          departmentId
          directWorkPhone
          doNotCall
          emailOptOut
          fax
          firstName
          homePhone
          id
          lastName
          localFirstName
          localLastName
          localMiddleName
          mailingAddressLine1
          mailingAddressLine2
          mailingCountryId
          mailingPoZipCode
          mailingStateProvinceId
          middleName
          mobilePhone
          notes
          otherAddressLine1
          otherAddressLine2
          otherCity
          otherCountryId
          otherPhone
          otherPoZipCode
          otherStateProvinceId
          personalEmail
          preferredLanguageId
          receiveAbbreviatedReportPdf
          receiveArtifactsAsLinks
          receiveFinalReportPdf
          receiveInvoice
          receiveQuote
          salutation
          status
          suffix
          title
          updatedById
          version
          workEmail
        }
      }
    }
  }
`;
